export default __webpack_public_path__ + "static/projects_gallery1-1e4fd269ba8de94b67e49d8ac2a12d79.webp";